<template>

<v-footer class="secondary" dark padless :style="$vuetify.breakpoint.name ==='xs' || $vuetify.breakpoint.name ==='sm' ? 'padding-bottom:68px' : 'padding-bottom:50px'">
  <v-col
    class="text-center"
    cols="12"
  >
  <v-card flat tile class="secondary  white--text text-center">


    <v-card-text>
      <v-btn v-for="(link,i) in $store.state.website.footer.social_links" :key="i" class="mx-4 white--text" icon :href="link" target="_blank">
        <v-icon size="24px">{{$helpers.linkIcon(link)}}</v-icon>
      </v-btn>
    </v-card-text>

    <v-card-text class="white--text pt-0">
      {{$store.state.website.footer.description}}
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="white--text">
    <router-link to="/" class="nolink white--text"><strong>WhyBuy</strong></router-link>
      <span class="mx-2">-</span>
       <span class="mr-2">&copy; {{ new Date().getFullYear() }}</span>
        <router-link class="nolink" to="/terms">Terms</router-link>
      <span class="mx-2">-</span>
      <router-link class="nolink" to="/privacy">Privacy</router-link>
    </v-card-text>
    <v-card-text>
     
    </v-card-text>


  </v-card>
</v-col>

</v-footer>
</template>
<script>
export default {
  name: "",
  data: () => ({})
}
</script>
<style lang="scss" scoped>
</style>
